/* eslint-disable array-callback-return */
import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import HyperLinkCard from "../HyperLinkCard";
import somethingWentWrong from "../../../../../assets/No_Data_Found.svg";
import IsEmpty from "../../../../utils/IsEmpty";
import {
  getPaneIndex,
  getWindowLocationPath,
} from "../../../../../redux/constants";
import isEqual from "react-fast-compare";

const Locations = ({ tabId }) => {
  const activeKey = useSelector((state) => state?.Tab1?.activeKey);
  const panes = useSelector((state) => state?.Tab1?.panes);
  const widgetLoaders = useSelector((state) => state?.DeepDive?.widgetLoaders);
  const index = getPaneIndex(panes, activeKey);
  const shareTemplateData = useSelector(
    (state) => state.ApiCall.shareTemplateData
  );
  const screen = useSelector((state) => state?.Screens?.screen);
  let pathName = getWindowLocationPath()?.toLowerCase();
  const graphConditionConfig = useSelector(
    (state) => state?.apiCall?.graphConditions
  );
  const locationsData =
    pathName === "CommandCenter"?.toLowerCase()
      ? screen?.deep_dive?.locations
      : shareTemplateData
      ? shareTemplateData?.deep_dive?.locations
      : panes[index]?.deep_dive?.locations;
  // const [windowSize, setwindowSize] = useState(1340);

  // const updateSize = () => {
  //   setwindowSize(window.screen.width);
  // };
  // useEffect(() => {
  //   window.addEventListener("resize", updateSize);
  //   // updateSize();
  //   return () => window.removeEventListener("resize", updateSize);
  // }, []);

  const finalData = IsEmpty(locationsData);
  return !finalData ? (
    <div className="row mr-md-0 LocationProfiles">
      {widgetLoaders[`Location Profiles`]?.map((isLoading, i) => {
        return locationsData[i]?.status === "successful" ? (
          locationsData[i]?.result?.span === "half" ? (
            <div className="col-12 col-md-6 pr-md-0">
              <HyperLinkCard
                data={locationsData[i]?.result}
                index={i}
                isLoading={isLoading}
                tabs_type="locations"
                deepDive={true}
              />
            </div>
          ) : (
            locationsData[i]?.result?.span === "full" && (
              <div className="col-12 col-md-12 pr-md-0">
                <HyperLinkCard
                  data={locationsData[i]?.result}
                  index={i}
                  isLoading={isLoading}
                  tabs_type="locations"
                  deepDive={true}
                  //   highlightWord={
                  //     graphConditionConfig?.["wordcloud-hide-unhide"]?.includes(
                  //       influencers_object?.deepdive_on?.x_axis?.attribute
                  //     )
                  //       ? influencers_object?.deepdive_on?.x_axis?.value?.toLocaleString()
                  //       : ""
                  //   }
                />
              </div>
            )
          )
        ) : locationsData[i]?.status === "error" ? (
          <div
            className={`col-12 h-100 col-md-${
              locationsData[i]?.span === "half"
                ? "6"
                : locationsData[i]?.span === "full"
                ? "12"
                : "6"
            } pr-md-0 portlet_images mb-15`}
          >
            <div className="DeepDive__Widget portlet p-0 border-radius-4">
              {locationsData?.[i]?.graph_name && (
                <div className="DeepDive__Widget--header portlet__title fontSize-16 p-15 border-bottom border-color font-weight500">
                  {locationsData?.[i]?.graph_name}
                </div>
              )}

              <div
                className="DeepDive__Widget--body d-flex justify-content-center align-items-center"
                style={{ height: "48rem" }}
              >
                <div className="text-center">
                  <img
                    alt="no data"
                    src={somethingWentWrong}
                    style={{ maxWidth: "100%", minWidth: "20rem" }}
                  />

                  <p className="mt-15 text_regular-gray">No Data Found</p>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="col-12 col-md-12 pr-md-0">
            <HyperLinkCard
              data={locationsData[i]?.result}
              index={i}
              isLoading={isLoading}
              deepDive={true}
              //   highlightWord={
              //     graphConditionConfig?.["wordcloud-hide-unhide"]?.includes(
              //       influencers_object?.deepdive_on?.x_axis?.attribute
              //     )
              //       ? influencers_object?.deepdive_on?.x_axis?.value?.toLocaleString()
              //       : ""
              //   }
            />
          </div>
        );
      })}
    </div>
  ) : (
    <div className="loader" style={{ height: "calc(100vh - 31rem)" }}>
      <div className="lds-ring">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  );
};

export default React.memo(Locations, isEqual);
